const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20round%20avatar%20in%20warm%20crimson%20gradient%20tones%2C%20simple%20geometric%20design%2C%20no%20text%20no%20face&width=100&height=100&seq=av01-51-018&orientation=squarish',
    time: '25分钟前',
    content: '这瓜太大了！我就说那个综艺肯定不会太平，没想到直接在录制现场翻脸。等后续更新！',
    likes: 1283,
  },
  {
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20round%20avatar%20in%20warm%20amber%20gradient%2C%20simple%20geometric%20circle%2C%20no%20text%20no%20face&width=100&height=100&seq=av02-51-019&orientation=squarish',
    time: '1小时前',
    content: '每天睡前必刷吃瓜网51，比刷短视频还上瘾。最近的爆料质量越来越高了，支持！',
    likes: 867,
  },
  {
    name: '真相挖掘机',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20round%20avatar%20in%20dark%20warm%20red%20gradient%2C%20simple%20geometric%20form%2C%20no%20text%20no%20face&width=100&height=100&seq=av03-51-020&orientation=squarish',
    time: '2小时前',
    content: '那个导演的瓜我之前就听说过，终于有人实名举报了。希望这次能查个水落石出。',
    likes: 2105,
  },
  {
    name: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20round%20avatar%20in%20golden%20warm%20tones%2C%20simple%20geometric%20style%2C%20no%20text%20no%20face&width=100&height=100&seq=av04-51-021&orientation=squarish',
    time: '4小时前',
    content: '作为老吃瓜人了，从这个站建站就在追。内容越来越丰富，分类也很清晰，安利给所有爱八卦的朋友！',
    likes: 567,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">吃瓜评论</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4 text-xs text-foreground-400 pl-13">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {comment.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}